/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  AddShopStockBotRequest,
  AddShopStockWatchRequest,
  ApiEnvelopeShopStockBotDetailResponse,
  ApiEnvelopeShopStockBotDto,
  ApiEnvelopeShopStockBotListResponse,
  ApiEnvelopeShopStockCompareResponse,
  ApiEnvelopeShopStockDeleteResponse,
  ApiEnvelopeShopStockItemsResponse,
  ApiEnvelopeShopStockSnapshotResponse,
  ApiEnvelopeShopStockWatchedBotDto,
  ApiEnvelopeShopStockWatchlistResponse,
  ShopStockGetWatchlistParams,
  ShopStockItemsRequest,
  UpdateShopStockBotRequest
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type shopStockListBotsResponse200 = {
  data: ApiEnvelopeShopStockBotListResponse
  status: 200
}

export type shopStockListBotsResponseSuccess = (shopStockListBotsResponse200) & {
  headers: Headers;
};
;

export type shopStockListBotsResponse = (shopStockListBotsResponseSuccess)

export const getShopStockListBotsUrl = () => {




  return `/api/shopstock/bots`
}

export const useShopStockListBotsHook = (): ( options?: RequestInit) => Promise<shopStockListBotsResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getShopStockListBotsUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type shopStockAddBotResponse200 = {
  data: ApiEnvelopeShopStockBotDto
  status: 200
}

export type shopStockAddBotResponse400 = {
  data: ApiEnvelopeShopStockBotDto
  status: 400
}

export type shopStockAddBotResponse401 = {
  data: ApiEnvelopeShopStockBotDto
  status: 401
}

export type shopStockAddBotResponseSuccess = (shopStockAddBotResponse200) & {
  headers: Headers;
};
export type shopStockAddBotResponseError = (shopStockAddBotResponse400 | shopStockAddBotResponse401) & {
  headers: Headers;
};

export type shopStockAddBotResponse = (shopStockAddBotResponseSuccess | shopStockAddBotResponseError)

export const getShopStockAddBotUrl = () => {




  return `/api/shopstock/bots`
}

export const useShopStockAddBotHook = (): (addShopStockBotRequest?: AddShopStockBotRequest, options?: RequestInit) => Promise<shopStockAddBotResponse> => {

      const customFetcher = useSfetchMutator();
      return (addShopStockBotRequest?: AddShopStockBotRequest, options?: RequestInit) => {

        return customFetcher(getShopStockAddBotUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(addShopStockBotRequest)
  }
);
      }
  }


export type shopStockGetSnapshotResponse200 = {
  data: ApiEnvelopeShopStockSnapshotResponse
  status: 200
}

export type shopStockGetSnapshotResponseSuccess = (shopStockGetSnapshotResponse200) & {
  headers: Headers;
};
;

export type shopStockGetSnapshotResponse = (shopStockGetSnapshotResponseSuccess)

export const getShopStockGetSnapshotUrl = () => {




  return `/api/shopstock/snapshot`
}

export const useShopStockGetSnapshotHook = (): ( options?: RequestInit) => Promise<shopStockGetSnapshotResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getShopStockGetSnapshotUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type shopStockGetBotResponse200 = {
  data: ApiEnvelopeShopStockBotDetailResponse
  status: 200
}

export type shopStockGetBotResponse400 = {
  data: ApiEnvelopeShopStockBotDetailResponse
  status: 400
}

export type shopStockGetBotResponseSuccess = (shopStockGetBotResponse200) & {
  headers: Headers;
};
export type shopStockGetBotResponseError = (shopStockGetBotResponse400) & {
  headers: Headers;
};

export type shopStockGetBotResponse = (shopStockGetBotResponseSuccess | shopStockGetBotResponseError)

export const getShopStockGetBotUrl = (id: string,) => {




  return `/api/shopstock/bots/${id}`
}

export const useShopStockGetBotHook = (): (id: string, options?: RequestInit) => Promise<shopStockGetBotResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string, options?: RequestInit) => {

        return customFetcher(getShopStockGetBotUrl(id),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type shopStockUpdateBotResponse200 = {
  data: ApiEnvelopeShopStockBotDto
  status: 200
}

export type shopStockUpdateBotResponse400 = {
  data: ApiEnvelopeShopStockBotDto
  status: 400
}

export type shopStockUpdateBotResponseSuccess = (shopStockUpdateBotResponse200) & {
  headers: Headers;
};
export type shopStockUpdateBotResponseError = (shopStockUpdateBotResponse400) & {
  headers: Headers;
};

export type shopStockUpdateBotResponse = (shopStockUpdateBotResponseSuccess | shopStockUpdateBotResponseError)

export const getShopStockUpdateBotUrl = (id: string,) => {




  return `/api/shopstock/bots/${id}`
}

export const useShopStockUpdateBotHook = (): (id: string,
    updateShopStockBotRequest?: UpdateShopStockBotRequest, options?: RequestInit) => Promise<shopStockUpdateBotResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    updateShopStockBotRequest?: UpdateShopStockBotRequest, options?: RequestInit) => {

        return customFetcher(getShopStockUpdateBotUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateShopStockBotRequest)
  }
);
      }
  }


export type shopStockDeleteBotResponse200 = {
  data: ApiEnvelopeShopStockDeleteResponse
  status: 200
}

export type shopStockDeleteBotResponse400 = {
  data: ApiEnvelopeShopStockDeleteResponse
  status: 400
}

export type shopStockDeleteBotResponseSuccess = (shopStockDeleteBotResponse200) & {
  headers: Headers;
};
export type shopStockDeleteBotResponseError = (shopStockDeleteBotResponse400) & {
  headers: Headers;
};

export type shopStockDeleteBotResponse = (shopStockDeleteBotResponseSuccess | shopStockDeleteBotResponseError)

export const getShopStockDeleteBotUrl = (id: string,) => {




  return `/api/shopstock/bots/${id}`
}

export const useShopStockDeleteBotHook = (): (id: string, options?: RequestInit) => Promise<shopStockDeleteBotResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string, options?: RequestInit) => {

        return customFetcher(getShopStockDeleteBotUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


export type shopStockRefetchBotResponse200 = {
  data: ApiEnvelopeShopStockBotDto
  status: 200
}

export type shopStockRefetchBotResponse400 = {
  data: ApiEnvelopeShopStockBotDto
  status: 400
}

export type shopStockRefetchBotResponse401 = {
  data: ApiEnvelopeShopStockBotDto
  status: 401
}

export type shopStockRefetchBotResponseSuccess = (shopStockRefetchBotResponse200) & {
  headers: Headers;
};
export type shopStockRefetchBotResponseError = (shopStockRefetchBotResponse400 | shopStockRefetchBotResponse401) & {
  headers: Headers;
};

export type shopStockRefetchBotResponse = (shopStockRefetchBotResponseSuccess | shopStockRefetchBotResponseError)

export const getShopStockRefetchBotUrl = (id: string,) => {




  return `/api/shopstock/bots/${id}/refetch`
}

export const useShopStockRefetchBotHook = (): (id: string, options?: RequestInit) => Promise<shopStockRefetchBotResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string, options?: RequestInit) => {

        return customFetcher(getShopStockRefetchBotUrl(id),
  {
    ...options,
    method: 'POST'


  }
);
      }
  }


export type shopStockGetWatchlistResponse200 = {
  data: ApiEnvelopeShopStockWatchlistResponse
  status: 200
}

export type shopStockGetWatchlistResponse401 = {
  data: ApiEnvelopeShopStockWatchlistResponse
  status: 401
}

export type shopStockGetWatchlistResponseSuccess = (shopStockGetWatchlistResponse200) & {
  headers: Headers;
};
export type shopStockGetWatchlistResponseError = (shopStockGetWatchlistResponse401) & {
  headers: Headers;
};

export type shopStockGetWatchlistResponse = (shopStockGetWatchlistResponseSuccess | shopStockGetWatchlistResponseError)

export const getShopStockGetWatchlistUrl = (params?: ShopStockGetWatchlistParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/shopstock/watchlist?${stringifiedParams}` : `/api/shopstock/watchlist`
}

export const useShopStockGetWatchlistHook = (): (params?: ShopStockGetWatchlistParams, options?: RequestInit) => Promise<shopStockGetWatchlistResponse> => {

      const customFetcher = useSfetchMutator();
      return (params?: ShopStockGetWatchlistParams, options?: RequestInit) => {

        return customFetcher(getShopStockGetWatchlistUrl(params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type shopStockAddWatchResponse200 = {
  data: ApiEnvelopeShopStockWatchedBotDto
  status: 200
}

export type shopStockAddWatchResponse400 = {
  data: ApiEnvelopeShopStockWatchedBotDto
  status: 400
}

export type shopStockAddWatchResponse401 = {
  data: ApiEnvelopeShopStockWatchedBotDto
  status: 401
}

export type shopStockAddWatchResponseSuccess = (shopStockAddWatchResponse200) & {
  headers: Headers;
};
export type shopStockAddWatchResponseError = (shopStockAddWatchResponse400 | shopStockAddWatchResponse401) & {
  headers: Headers;
};

export type shopStockAddWatchResponse = (shopStockAddWatchResponseSuccess | shopStockAddWatchResponseError)

export const getShopStockAddWatchUrl = () => {




  return `/api/shopstock/watchlist`
}

export const useShopStockAddWatchHook = (): (addShopStockWatchRequest?: AddShopStockWatchRequest, options?: RequestInit) => Promise<shopStockAddWatchResponse> => {

      const customFetcher = useSfetchMutator();
      return (addShopStockWatchRequest?: AddShopStockWatchRequest, options?: RequestInit) => {

        return customFetcher(getShopStockAddWatchUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(addShopStockWatchRequest)
  }
);
      }
  }


export type shopStockRemoveWatchResponse200 = {
  data: ApiEnvelopeShopStockDeleteResponse
  status: 200
}

export type shopStockRemoveWatchResponse400 = {
  data: ApiEnvelopeShopStockDeleteResponse
  status: 400
}

export type shopStockRemoveWatchResponse401 = {
  data: ApiEnvelopeShopStockDeleteResponse
  status: 401
}

export type shopStockRemoveWatchResponseSuccess = (shopStockRemoveWatchResponse200) & {
  headers: Headers;
};
export type shopStockRemoveWatchResponseError = (shopStockRemoveWatchResponse400 | shopStockRemoveWatchResponse401) & {
  headers: Headers;
};

export type shopStockRemoveWatchResponse = (shopStockRemoveWatchResponseSuccess | shopStockRemoveWatchResponseError)

export const getShopStockRemoveWatchUrl = (botId: string,) => {




  return `/api/shopstock/watchlist/${botId}`
}

export const useShopStockRemoveWatchHook = (): (botId: string, options?: RequestInit) => Promise<shopStockRemoveWatchResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string, options?: RequestInit) => {

        return customFetcher(getShopStockRemoveWatchUrl(botId),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


export type shopStockCompareItemResponse200 = {
  data: ApiEnvelopeShopStockCompareResponse
  status: 200
}

export type shopStockCompareItemResponse400 = {
  data: ApiEnvelopeShopStockCompareResponse
  status: 400
}

export type shopStockCompareItemResponseSuccess = (shopStockCompareItemResponse200) & {
  headers: Headers;
};
export type shopStockCompareItemResponseError = (shopStockCompareItemResponse400) & {
  headers: Headers;
};

export type shopStockCompareItemResponse = (shopStockCompareItemResponseSuccess | shopStockCompareItemResponseError)

export const getShopStockCompareItemUrl = (itemId: string,) => {




  return `/api/shopstock/compare/${itemId}`
}

export const useShopStockCompareItemHook = (): (itemId: string, options?: RequestInit) => Promise<shopStockCompareItemResponse> => {

      const customFetcher = useSfetchMutator();
      return (itemId: string, options?: RequestInit) => {

        return customFetcher(getShopStockCompareItemUrl(itemId),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type shopStockGetItemsResponse200 = {
  data: ApiEnvelopeShopStockItemsResponse
  status: 200
}

export type shopStockGetItemsResponse400 = {
  data: ApiEnvelopeShopStockItemsResponse
  status: 400
}

export type shopStockGetItemsResponse401 = {
  data: ApiEnvelopeShopStockItemsResponse
  status: 401
}

export type shopStockGetItemsResponseSuccess = (shopStockGetItemsResponse200) & {
  headers: Headers;
};
export type shopStockGetItemsResponseError = (shopStockGetItemsResponse400 | shopStockGetItemsResponse401) & {
  headers: Headers;
};

export type shopStockGetItemsResponse = (shopStockGetItemsResponseSuccess | shopStockGetItemsResponseError)

export const getShopStockGetItemsUrl = () => {




  return `/api/shopstock/items`
}

export const useShopStockGetItemsHook = (): (shopStockItemsRequest?: ShopStockItemsRequest, options?: RequestInit) => Promise<shopStockGetItemsResponse> => {

      const customFetcher = useSfetchMutator();
      return (shopStockItemsRequest?: ShopStockItemsRequest, options?: RequestInit) => {

        return customFetcher(getShopStockGetItemsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(shopStockItemsRequest)
  }
);
      }
  }


